import React from 'react';
import emailjs from '@emailjs/browser';

const ContactForm = () => {
  const onSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const form = event.currentTarget;
    const nameInput = (form.elements.namedItem('name') as HTMLInputElement).value;

    if (/\d/.test(nameInput)) {
      alert('Name should not contain numbers.');
      return;
    }

    try {
      const timeInput = document.createElement('input');
      timeInput.type = 'hidden';
      timeInput.name = 'to_email';
      timeInput.value = process.env.REACT_APP_EMAILJS_RECEIVER || '';
      form.appendChild(timeInput);

      const timeInput2 = document.createElement('input');
      timeInput2.type = 'hidden';
      timeInput2.name = 'time';
      timeInput2.value = new Date().toLocaleString('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      });
      form.appendChild(timeInput2);

      await emailjs.sendForm(process.env.REACT_APP_EMAILJS_SERVICE_ID || '', process.env.REACT_APP_EMAILJS_TEMPLATE_ID || '', form, process.env.REACT_APP_EMAILJS_PUBLIC_KEY || '');

      alert('Your message has been sent successfully!');
      form.reset();

      form.removeChild(timeInput);
      form.removeChild(timeInput2);
    } catch (error) {
      console.error('Failed to send email:', error);
      alert('Failed to send the message. Please try again later.');
    }
  };

  return (
    <div className='contactFormContainer'>
      <div className='contactForm'>
        <form onSubmit={onSubmit}>
          <div className='formGroupContents'>
            <div className='formGroup'>
              <label htmlFor='name'>Name</label>
              <input type='text' id='name' className='name' name='name' required />
            </div>
            <div className='formGroup'>
              <label htmlFor='email'>Email</label>
              <input type='email' id='email' className='email' name='email' required />
            </div>
            <div className='formGroup'>
              <label htmlFor='phone'>Phone</label>
              <input type='tel' id='phone' className='phone' name='phone' required />
            </div>

            <div className='formGroupMessage'>
              <label htmlFor='message' className='Message'>Message</label>
              <textarea id='message' name='message' required></textarea>
            </div>
          </div>

          <div className='formGroupButton'>
            <div className='formGroupSubmit'>
              <button type='submit'>Submit</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ContactForm;